     <ng-container *ngIf="planillaGenerate == true">
<section class="container-fluid shadow pt-3 pb-2 text-white backgroundTable mt-3 " style="min-height:70px !important;">

    <div>
        <h5 class="ms-3">Generar nomina</h5>
    </div>
    <div class="componente-importantes text-start p-5 mt-3" style="min-height:70px;">
        <div class="container-fluid ">
            <form action="" action="" class="container-fluid needs-validation" method="post" (submit)="formSubmit()"
                [formGroup]="Step4form">

                <div class="">
                    <label class="form-label mb-4">Generar nómina mensual</label>
                </div>

                <div class="row align-items-end">


                    <div class="col-4 col-lg-6 col-xl-3 ">
                        <label class="form-label">Tipo de servicio</label>

                        <select required class="custom-outline-input form-select mt-3" formControlName="project_type">
                            <option value="">Seleccione...</option>
                            <option value="1">TAAS</option>
                            <option value="2">PROYECTO</option>
                            <option value="3">ADMINISTRACION</option>
                        </select>

                        <div class="invalid-feedback">
                            Seleccione un Tipo de proyecto.
                        </div>
                    </div>

                    <div class="col-4 col-lg-6 col-xl-3">
                        <label class="form-label">Fecha</label>
                        <input required type="date" class="custom-outline-input date w-100" id="start_date"
                            formControlName="start_date" [max]="today">

                        <div class="invalid-feedback">
                            Seleccione una fecha.
                        </div>
                    </div>

                    <div class="col-4 col-lg-4 col-xl-3">
                        <label class="form-label">Agregar Archivo</label>
                        <input (change)="onFileSelected($event)" required type="file"
                            class="custom-outline-input form-control" formControlName="archive" accept=".xls,.xlsx">

                        <div class="invalid-feedback">
                            Seleccione un archivo.
                        </div>
                    </div>

                    <div class="col-3 col-lg-3 col-xl-3 d-flex justify-content-end mt-lg-2 mt-xl-0">
                        <button class="btn btn-outline-light w-100">
                            <i class="fa-solid fa-floppy-disk me-1"></i>
                            Generar
                        </button>
                    </div>

                </div>

            </form>
        </div>
    </div>

</section>

<section class="container-fluid shadow pt-3 pb-2 text-white backgroundTable mt-3 " style="min-height:70px !important;">

    <div>
        <h5 class="ms-3">Generar Lista de proyecto historico</h5>
    </div>
    <div class="componente-importantes text-start p-5 mt-3" style="min-height:70px;">
        <div class="container-fluid ">
            <form action="" action="" class="container-fluid needs-validation-2" method="post" (submit)="formSubmitProject()"
                [formGroup]="Step2form">

                <div class="">
                    <label class="form-label mb-4">Generar nómina mensual</label>
                </div>

                <div class="row align-items-end">


                    <div class="col-md-4 col-lg-4">
                        <label class="form-label">Tipo de servicio</label>

                        <select required class="custom-outline-input form-select mt-3" formControlName="project_type">
                            <option value="">Seleccione...</option>
                            <option value="2">TAAS</option>
                            <option value="1">PROYECTO</option>
                            <option value="3">SERVICIO</option>
                        </select>

                        <div class="invalid-feedback">
                            Seleccione un Tipo de proyecto.
                        </div>
                    </div>

                    <div class="col-md-4 col-lg-3">
                        <label for="sucursal" class="form-label text-color">Año </label>
                        <select required class="mx-1 custom-outline-input form-select w-auto " aria-label="Default select" formControlName="start_date">
                        <option value="">Año</option>
                        <option value="{{option.id}}" *ngFor="let option of listYear">
                        {{option.name}}
                        </option>
                    </select>

                       <div class="invalid-feedback">
                            Seleccione un año
                        </div>
                    </div>

                    <div class="col-md-2 d-flex justify-content-end mt-md-2">
                        <button class="btn btn-outline-light w-100">
                            <i class="fa-solid fa-floppy-disk me-1"></i>
                            Generar
                        </button>
                    </div>

                </div>

            </form>
        </div>
    </div>

</section>

</ng-container>

     <ng-container *ngIf="syncTaas == true">
<section class="container-fluid shadow pt-3 pb-2 text-white backgroundTable mt-3 " style="min-height:70px !important;">

    <div>
        <h5 class="ms-3">Sincronizar planilla TaaS de seguimiento</h5>
    </div>
    <div class="componente-importantes text-start p-5 mt-3" style="min-height:70px;">
        <div class="container-fluid ">

        
                <div class="row align-items-end">

                    <div class="col-md-2 d-flex justify-content-end mt-md-2">
                        <button class="btn btn-outline-light w-100" (click)="Sync()">
                            <i class="fa-solid fa-floppy-disk me-1"></i>
                            Sincronizar
                        </button>
                    </div>

                </div>

        </div>
    </div>

</section>
</ng-container>